<template>
  <v-container id="viaticos" fluid tag="section" class="pa-0 ma-0">
    <base-material-card color="#ac8a2e" icon="mdi-note-multiple" inline class="px-5 py-3" :title="title">
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="buscar" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />
      <v-data-table
        :headers="headers"
        :items="viaticos"
        :search.sync="buscar"
        :sort-desc="[true, false]"
        multi-sort
        @click:row="showItem"
      >
        <template v-if="pendiente && $can('M_viaticos')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-if="pendiente && $can('M_pagos')" v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToPagos(item)">
                mdi-text-box-plus-outline
              </v-icon>
            </template>
            <span>Nuevo pago</span>
          </v-tooltip>
          <v-tooltip v-if="pendiente && $can('M_pagos')" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" v-bind="attrs" v-on="on" @click.stop="rechazarItem(item)">
                mdi-close-box-multiple-outline
              </v-icon>
            </template>
            <span>Rechazar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToViaticoForm('edit', item.id)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
        <template v-if="!pendiente" v-slot:[`item.pagos_id`]="{ item }">
          <v-icon
            v-if="(item.valor_monetario > 0 || item.pagos_id)"
            medium
            color="green"
          >
            mdi-checkbox-marked-circle-outline
          </v-icon>
        </template>
        <template v-if="!pendiente && $can('M_viaticos')" v-slot:[`item.fecha_rechazo`]="{ item }">
          <v-icon
            v-if="item.fecha_rechazo"
            medium
            color="green"
          >
            mdi-checkbox-marked-circle-outline
          </v-icon>
        </template>
      </v-data-table>
    </base-material-card>
    <v-col
      cols="auto"
    >
      <v-dialog
        v-model="dialogRechazar"
        max-width="500px"
      >
        <v-card>
          <template>
            <v-col cols="12" class="pa-0">
              <v-card-title class="headline">
                Rechazar Viático
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="motivo rechazo"
                        rules="required|max:250"
                      >
                        <v-textarea
                          v-model="dataForm.motivo_rechazo"
                          color="#ac8a2e"
                          :error-messages="errors"
                          name="input-6-1"
                          label="Motivo Rechazo"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-col>
          </template>
          <v-card-actions>
            <v-spacer />
            <v-btn color="red" large text @click="closeRechazar">
              Cancelar
            </v-btn>
            <v-btn color="blue darken-1" large text @click="updateItem">
              Aceptar
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import dayjs from 'dayjs'
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    props: {
      url: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      mode: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        buscar: '',
        currentRow: '',
        pendiente: false,
        dialogRechazar: false,
        editedIndex: -1,
        viaticos: [],
        headers: [],
        headersPagos: [
          { text: 'Fecha', align: 'start', sortable: true, value: 'fecha' },
          { text: 'Monto', sortable: true, value: 'monto' },
        ],
        dataForm: {

        },
      }
    },
    watch: {

    },
    created () {
      this.setHeaders()
      this.getViaticos()
      if (this.mode === 'pendientes') {
        this.pendiente = true
      }
    },
    methods: {

      setHeaders: function () {
        if (this.mode === 'pendientes') {
          this.headers = [
            { text: 'Fecha', align: 'start', sortable: true, value: 'fecha' },
            { text: 'Jugador', align: 'start', sortable: true, value: 'jugador.fullName' },
            { text: 'Tipo', sortable: true, value: 'obligacion.descripcion' },
            { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
          ]
        } else {
          this.headers = [
            { text: 'Fecha', align: 'start', sortable: true, value: 'fecha' },
            { text: 'Jugador', align: 'start', sortable: true, value: 'jugador.fullName' },
            { text: 'Tipo', sortable: true, value: 'obligacion.descripcion' },
            { text: 'Pago', value: 'pagos_id' },
            { text: 'Rechazado', value: 'fecha_rechazo' },
          ]
        }
      },

      rowClick: async function (item, row) {
        row.select(true)
        this.currentRow = row
      },

      getViaticos: async function () {
        this.$store.dispatch('axiosMod/getData', { url: this.url }).then(response => { this.viaticos = response })
      },

      goToViaticoForm (modeVal, viaticoId) {
        this.$router.push({ name: 'Alta viaticos', params: { mode: modeVal, id: viaticoId } })
      },

      goToPagos (item) {
        this.$router.push({ name: 'Pagos', params: { id: 0, mode: 'precargado', idJugador: item.jugador_id, idContrato: 0, idObligacion: 0, idSolicitud: item.id } })
      },

      showItem (item) {
        this.goToViaticoForm('show', item.id)
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/solicitudes_extraordinarias_eliminar/' + item.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Viático eliminado'] })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getViaticos()
      },

      rechazarItem (item) {
        this.editedIndex = this.viaticos.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dataForm.fecha_rechazo = dayjs().format('YYYY-MM-DD')
        this.dialogRechazar = true
      },

      closeRechazar () {
        this.dialogRechazar = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      updateItem: async function () {
        await this.$http({
          method: 'put',
          url: '/api/solicitudes_extraordinarias_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Viático rechazado'] })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
        this.getViaticos()
        this.closeRechazar()
      },
    },
  }
</script>

<style>
  tr.v-data-table__selected {
  background: #7d92f5 !important;
}
</style>
